
export default {
  name: "VideoBanner",

  props: { slice: { type: Object, required: true } },
};
